import React, { useEffect } from "react"

import { offices, reports, searchID, singleDate } from "@signals"
import { useAnalyzerDirectSitesFilters } from "./@hooks"
import { directSiteSchema } from "./schema"
import AnalyzerCommonFilters from "Pages/AnalyzersV2/Filters"


export default function DirectSitesFilter() {
	const { onSubmit, isValid, errors } = useAnalyzerDirectSitesFilters()
	useEffect(() => {
		singleDate.value = null
	}, [reports.value, offices.value])

	return <AnalyzerCommonFilters
		components={{
			mainProvider: false,
			lengthRental: !!offices.value && !!reports.value || searchID.value,
			webProviderToggle: false,
			acrissCategoryToggle: true,
			// Out of scope: on direct sites the web is the provider's own, so the
			// web supplier adds nothing to read.
			webSuppliers: false
		}}
		compProps={{
			mainSite: { filters: { getDirectSites: true } },
			sites: { filters: { getDirectSites: true } },
		}}
		onSubmit={onSubmit}
		isValid={isValid}
		errors={errors}
		schema={directSiteSchema}
	/>
}